/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule, LazyloadService } from '@dm/core';

import { CreateFileShareModule } from '../../file-system/create-file-share/create-file-share.module';
import { CreateNfsShareModule } from './create-nfs-share/create-nfs-share.module';
import { DeleteNfsShareModule } from './delete-nfs-share/delete-nfs-share.module';
import { DetailNfsShareModule } from './detail-nfs-share/detail-nfs-share.module';
import { ModifyNfsShareModule } from './modify-nfs-share/modify-nfs-share.module';
import { NfsShareComponent } from './nfs-share.component';
import { NfsShareService } from './nfs-share.service';
import { NfsShareStrService } from './nfs-share-str.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        CreateFileShareModule,
        CreateNfsShareModule,
        DeleteNfsShareModule,
        ModifyNfsShareModule,
        DetailNfsShareModule,
    ],
    declarations: [NfsShareComponent],
    exports: [NfsShareComponent],
    providers: [
        LazyloadService,
        NfsShareStrService,
        NfsShareService,
    ],
})
export class NfsShareModule { }
